module.exports = `
  type Copyright{
    owner: String
    period: String
    producer: String
    producerHref: String
    done: Boolean
  }
`;
